module.exports = __webpack_public_path__ + "img/login-page.Actics.254df122.png";